import { createTheme } from '@mui/material/styles';

const getPalette = (mode) => {
  if (mode === 'dark') {
    return {
      mode: 'dark',
      primary: {
        main: '#FAFAFA',
        light: '#FFFFFF',
        dark: '#E4E4E7',
        contrastText: '#111111',
        mode: '#09090B',
        secondary: '#27272A',
        gray: '#A1A1AA',
        grayLabel: '#A1A1AA',
        services: '#FAFAFA',
        black: '#FAFAFA',
        error: '#f44336',
      },
      secondary: {
        main: '#FAFAFA',
      },
      background: {
        default: '#09090B',
        paper: '#18181B',
        card: '#1F1F23',
        muted: '#27272A',
      },
      text: {
        primary: '#FAFAFA',
        secondary: '#A1A1AA',
      },
      divider: '#27272A',
    };
  }

  return {
    mode: 'light',
    primary: {
      main: '#000000',
      light: '#3A3A3A',
      dark: '#000000',
      contrastText: '#FFFFFF',
      mode: '#FFFFFF',
      secondary: '#E4E4E7',
      gray: '#71717A',
      grayLabel: '#71717A',
      services: '#18181B',
      black: '#000000',
      error: '#f44336',
    },
    secondary: {
      main: '#000000',
    },
    background: {
      default: '#F4F4F5',
      paper: '#FFFFFF',
      card: '#FAFAFA',
      muted: '#EEEEEE',
    },
    text: {
      primary: '#111111',
      secondary: '#71717A',
    },
    divider: '#E4E4E7',
  };
};

export const createAppTheme = (mode = 'light') =>
  createTheme({
    direction: 'rtl',
    palette: getPalette(mode),
    shape: {
      borderRadius: 12,
    },
    typography: {
      fontFamily: 'iran-sans-light',
      textAlign: 'right',
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: (theme) => ({
          body: {
            backgroundColor: theme.palette.background.default,
            color: theme.palette.text.primary,
          },
        }),
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 10,
            textTransform: 'none',
            fontFamily: 'iran-sans-light',
            fontWeight: 600,
            boxShadow: 'none',
          },
          contained: ({ theme }) => ({
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            '&:hover': {
              backgroundColor: theme.palette.primary.light,
              boxShadow: 'none',
            },
            '&:active': {
              backgroundColor: theme.palette.primary.main,
            },
            '&.Mui-disabled': {
              backgroundColor: theme.palette.background.muted,
              color: theme.palette.text.secondary,
            },
          }),
          outlined: ({ theme }) => ({
            borderColor: theme.palette.divider,
            color: theme.palette.text.primary,
            borderWidth: 1.5,
            '&:hover': {
              borderColor: theme.palette.primary.main,
              backgroundColor:
                theme.palette.mode === 'dark'
                  ? 'rgba(255,255,255,0.06)'
                  : 'rgba(0,0,0,0.03)',
              borderWidth: 1.5,
            },
          }),
          text: ({ theme }) => ({
            color: theme.palette.text.primary,
          }),
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: ({ theme }) => ({
            color: theme.palette.text.primary,
          }),
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            fontWeight: 600,
          },
          filled: ({ theme }) => ({
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
          }),
          outlined: ({ theme }) => ({
            borderColor: theme.palette.divider,
            color: theme.palette.text.primary,
          }),
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
          },
          rounded: {
            borderRadius: 16,
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            borderRadius: 20,
          },
        },
      },
      MuiDivider: {
        styleOverrides: {
          root: ({ theme }) => ({
            borderColor: theme.palette.divider,
          }),
        },
      },
      MuiSwitch: {
        styleOverrides: {
          switchBase: ({ theme }) => ({
            '&.Mui-checked': {
              color: theme.palette.primary.main,
            },
            '&.Mui-checked + .MuiSwitch-track': {
              backgroundColor: theme.palette.primary.main,
              opacity: 1,
            },
          }),
        },
      },
      MuiCircularProgress: {
        styleOverrides: {
          root: ({ theme }) => ({
            color: theme.palette.primary.main,
          }),
        },
      },
      MuiAvatar: {
        styleOverrides: {
          root: ({ theme }) => ({
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
          }),
        },
      },
    },
  });
